module.exports = __webpack_public_path__ + "img/26.0358d411.jpg";